import React, { useState } from 'react'
import PropTypes from 'prop-types'
import { Collapse } from 'react-collapse'

import { Testable } from '@cred/react-testable'
import { Link as NoAnalyticsLink } from '@cred/react-link'
import { collapsibleClick } from '@cred/react-analytics/events'
import { withSnowplowContexts } from '@cred/react-analytics/SnowplowContextManager'

import { onlyMobile, exceptMobile } from 'common/visibility'
import PoweredBy from 'components/powered-by'
import FooterLinks, { Divider } from 'components/footer-links'

import Disclosures from '../disclosures'
import styles from './styles.modue.scss'

const RateWidgetFooter = ({ trackSnowplowEvent, hidePoweredBy = false }) => {
  const [isOpen, setOpen] = useState(false)
  const iconClass = isOpen ? 'icon-chevron-up' : 'icon-chevron-down'

  const toggleLenderList = () => {
    setOpen(!isOpen)

    trackSnowplowEvent(collapsibleClick, {
      text: 'Disclosures',
      action: isOpen ? 'collapse' : 'expand',
    })
  }

  return (
    <>
      <Testable className={styles.container} testId="footer">
        <FooterLinks containerClassName={styles.links}>
          <>
            <Divider />
            <NoAnalyticsLink data-for="disclosures" onClick={toggleLenderList}>
              <p className="disclaimer secondary500">
                Disclosures <span className={`cred-icon ${iconClass} ${styles.iconStyle}`} />
              </p>
            </NoAnalyticsLink>
          </>
        </FooterLinks>
        {!hidePoweredBy && <PoweredBy className={exceptMobile} />}
      </Testable>

      <Collapse isOpened={isOpen}>
        <Disclosures />
      </Collapse>
      {!hidePoweredBy && <PoweredBy className={`${onlyMobile} mt-16 ${styles.poweredBy}`} />}
    </>
  )
}

RateWidgetFooter.propTypes = {
  trackSnowplowEvent: PropTypes.func.isRequired,
  hidePoweredBy: PropTypes.bool,
}

export { RateWidgetFooter }

export default withSnowplowContexts(RateWidgetFooter)
